import axios from 'axios';
import { apiKey, apiCreateComment } from '../../config';
import { logoutUser } from '../../utils/authHandling/logout-user';

export const createCommentCall = async function(language, commentModel){
  let params = {
    APIKey: apiKey,
    Token: sessionStorage.athenasToken,
    LangCode: language,
    CommentModel: commentModel
  }
  try{
    const response = await axios.post(apiCreateComment, params);
    if(response.data.SessionValid){
      if(response.data.TransactionValid){
        //the post was saved correctly
        alert(response.data.Messages);
        return true;
      } else{
        alert(response.data.Messages);
        return false;
      }
    } else{
      //Session is not valid, therefore logout
      alert('Session is not valid.');
      logoutUser();
      return false;
    }
  } catch(error){
    alert(error.response.data.Messages);
    return false;
  }
}